// Live Tours — top-level route, gated behind VITE_FF_LIVE_TOURS.
// -----------------------------------------------------------------
// Per docs/architecture/dispatches/m7-2-production-tour-editor.md
// § 4 M7.2-E.
//
// Renders <LiveTourList> when the flag is on.
// Redirects to /hello when the flag is off (matching the M3.4
// placeholder pattern used by Tour Planner, Tour Curator, etc.).
//
// Flag flips at M7.2-L1 staging + M7.2-L2 prod per dispatch § 5.
// DO NOT touch .env.staging or .env.production (lead sets flags).

import { Navigate, createFileRoute } from '@tanstack/react-router';

import { LiveTourList } from '@/components/live-tours/LiveTourList';
import { isFeatureEnabled } from '@/lib/featureFlags';

const LiveToursRoute = () => {
  if (!isFeatureEnabled('LIVE_TOURS')) {
    return <Navigate to='/hello' replace />;
  }
  return <LiveTourList />;
};

export const Route = createFileRoute('/_authenticated/live-tours')({
  component: LiveToursRoute,
});
